import {client} from '../helpers/api';

export async function getBanners() {
  const response = await client.get('/v1/banner/list');

  if (response.data?.status) {
    return response.data?.data || [];
  }
  throw response;
}
